import { reaction } from 'mobx';
export const safeReaction = (rootStore, expression, effect, opts) => {
    if (!rootStore.propStateStore.isSsr) {
        reaction(expression, effect, opts);
    }
    else if (opts && opts.fireImmediately) {
        effect(expression(null), null, null);
    }
};
//# sourceMappingURL=MobxUtil.js.map